export default "__VITE_ASSET__uv2g5fMe__"